const Pills = {
  SELECTORS: {
    container: '[data-js-pills-container]',
    filter: '[data-js-pills-filter]',
    expandButton: '[data-js-pills-expand-button]',
    cta: '[data-js-pills-cta]',
  },
  CLASSES: {
    containerExpanded: 'pills--expanded',
    filter: 'pills__pill--active',
  },
  init() {
    const filters = document.querySelectorAll(this.SELECTORS.filter);

    filters.forEach((filter) => {
      filter.onclick = () => {
        if (filter.ariaPressed === 'true') {
          filter.classList.remove(this.CLASSES.filter);

          filter.ariaPressed = false;
        } else {
          filter.classList.add(this.CLASSES.filter);

          filter.ariaPressed = true;
        }

        this.updateCtaHref();
      };
    });

    const expandButton = document.querySelector(this.SELECTORS.expandButton);

    if (expandButton) {
      expandButton.onclick = () => {
        const container = document.querySelector(this.SELECTORS.container);

        container.classList.add(this.CLASSES.containerExpanded);
      };
    }
  },
  updateCtaHref() {
    const filters = document.querySelectorAll(this.SELECTORS.filter);
    const cta = document.querySelector(this.SELECTORS.cta);
    let parameters = '';
    let activeIndex = 0;

    filters.forEach((filter) => {
      if (filter.ariaPressed === 'true') {
        if (activeIndex > 0) {
          parameters += '&';
        }
        const parameterString = filter.getAttribute(this.SELECTORS.filter.replace('[', '').replace(']', ''));
        const processedParameterString = parameterString.replace('=', `[${activeIndex}]=`);
        const parameter = `refinementList${processedParameterString}`;

        parameters += `${parameter}`;
        ++activeIndex;
      }
    });

    cta.href = cta.href.split('?')[0] + `?${parameters}`;
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Pills.init();
});

document.addEventListener('shopify:section:load', () => {
  Pills.init();
});

document.addEventListener('shopify:section:reorder', () => {
  Pills.init();
});
